import React, { useEffect, useState } from "react";
import { DefaultLoader } from "../../components";
import { getSessionStorage, removeSessionStorage } from "../../utils/session";

const withProfileRedirect = WrappedComponent => {
  return function WithProfileRedirect(props) {
    const { profile, history } = props;
    const [masterId, setMasterId] = useState(null);
    const storageList = [
      "reqTokenDate",
      "persist:root",
      "mpUserInfo",
      "isNewUser",
      "currentTab",
      // "mpAccessToken",
      "mpUserStatus",
      // "mpBearerToken",
      // "renew",
      // "masterId",
    ];
    const cleanStorage = () => {
      for (let i = 0; i < storageList.length; i++) {
        localStorage.removeItem(storageList[i]);
      }
      removeSessionStorage("mpAccessToken");
      removeSessionStorage("mpBearerToken");
      removeSessionStorage("renew");
      removeSessionStorage("masterId");
      removeSessionStorage("isNewUser");
    };

    useEffect(() => {
      const fetchMasterId = async () => {
        const storedMasterId = await getSessionStorage("masterId");
        setMasterId(storedMasterId);
      };

      fetchMasterId();

      return () => {
        setMasterId(null);
      };
    }, []);

    useEffect(() => {
      // 1. existing customer will not have masterId, therefore the first condition will be truthy and the existing functionality will be the same as before
      // 2. new customer/existing user comming from get started will have masterId and profile condition will prevent any misredirection or
      // 3. blank screen, because we prevent the wrapped component to run because of this condition
      if ((!masterId && !profile) || (masterId && !profile)) {
        cleanStorage();
        history.push("/");
      }
    }, [profile, masterId]);

    if (masterId === null) return <DefaultLoader />;

    if (masterId && !profile) return <DefaultLoader />;

    if (!masterId && !profile) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };
};

export default withProfileRedirect;
